import { useMemo, useState } from 'react';
import { SortDescriptor } from '@ds';
import { RSAssignmentCandidate } from '@/api/apis/resources';
import { SurgeonTableBaseProps } from '../types';
import { useSurgeonsForAssignment } from '@/queries/resource';
import { EMPLOYEE_SURGEON_COLUMNS } from '../config';
import { searchEmployeeSurgeons } from '../utils';
import { renderEmployeeSurgeonTableCell } from './renderEmployeeSurgeonTableCell';
import { mapSelected, sortCandidates } from '../../utils';
import { CandidatesTable } from '../../components/CandidatesTable/CandidatesTable';

type EmployeeSurgeonsTableProps = SurgeonTableBaseProps & {
  onReserve: (surgeon: RSAssignmentCandidate) => void;
};

export const EmployeeSurgeonsTable = ({
  searchTerm,
  caseId,
  caseName,
  orTime,
  organ,
  donor,
  isLogistics,
  selectedSurgeonsIds,
  onReserve,
}: EmployeeSurgeonsTableProps) => {
  const [sort, setSort] = useState<SortDescriptor | undefined>();
  const { data: surgeons, isLoading } = useSurgeonsForAssignment({ caseId, donor, organ, orTime });

  const tableRows = useMemo(() => {
    const searchResults = searchEmployeeSurgeons(searchTerm, surgeons);
    const mappedSurgeons = mapSelected(selectedSurgeonsIds, searchResults, 'employeeId');

    return sortCandidates<RSAssignmentCandidate>(mappedSurgeons, sort);
  }, [sort, searchTerm, surgeons, selectedSurgeonsIds]);

  const renderCell = useMemo(
    () => renderEmployeeSurgeonTableCell(orTime, isLogistics, donor, onReserve, caseName),
    [orTime, isLogistics, donor, onReserve, caseName],
  );
  return (
    <CandidatesTable
      label="Retrieval surgeons for assignment"
      columns={EMPLOYEE_SURGEON_COLUMNS}
      renderCell={renderCell}
      data={tableRows}
      isLoading={false}
      isFetching={isLoading}
      sortBy={sort}
      onSortByChange={setSort}
    />
  );
};
